<template>
  <v-layout row wrap style="flex: 1 0; overflow: auto; align-items: flex-start">
    <v-flex xs6 class="inline-block px-4">
      <v-select
        hide-details
        :items="civilites"
        item-text="CIV_LIBELLE"
        item-value="CIV_ID"
        :label="$t('Admin.User.Form.Civility')"
        v-model="usr_civilite"
      ></v-select>
      <v-text-field hide-details :label="$t('Admin.User.Form.Name')" v-model="usr_nom" />
      <v-text-field hide-details :label="$t('Admin.User.Form.Surname')" v-model="usr_prenom" />
      <v-autocomplete
        hide-details
        :items="enseignes"
        item-text="ENS_LIBELLE"
        item-value="ENS_ID"
        :label="$t('Admin.User.Form.Company')"
        v-model="ens_id"
      ></v-autocomplete>
      <v-text-field hide-details :label="$t('Admin.User.Form.Login')" v-model="usr_login" />
      <v-text-field hide-details :label="$t('Admin.User.Form.Email')" v-model="usr_email" />
      <v-text-field hide-details :label="$t('Admin.User.Form.Phone')" v-model="usr_tel" />
      <v-text-field hide-details rows="5" :label="$t('Admin.User.Form.InternalNote')" v-model="usr_note_interne" />
      <v-text-field hide-details :label="$t('Admin.User.Form.Photo')" v-model="usr_photo_url" />
    </v-flex>
    <v-flex xs6 class="inline-block px-4">
      <v-select
        hide-details
        small-chips
        deletable-chips
        multiple
        clearable
        :items="roles"
        item-text="ROL_LIBELLE"
        item-value="ROL_KEY"
        :label="$t('Admin.User.Rights.SysRoleToAdd')"
        v-model="usr_roles"
      ></v-select>
    </v-flex>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'AdminUserForm',
})
export default class AdminUserForm extends Vue {
  get roles() {
    return this.$store.myGetters.roles
  }

  /*Cycle de vie*/
  created() {
    this.$store.myActions.ENSEIGNE_ENSURE_LIST()
    this.$store.myActions.ROLE_ENSURE_LIST()
  }

  get modified() {
    return this.$store.myGetters.modifiedAdmUser
  }

  get enseignes() {
    return this.$store.myGetters.enseignes
  }

  get civilites() {
    return [
      { CIV_LIBELLE: 'Madame', CIV_ID: 1 },
      { CIV_LIBELLE: 'Monsieur', CIV_ID: 2 },
    ]
  }

  get ens_id() {
    return this.modified.ENS_ID!
  }
  set ens_id(value: number) {
    this.$store.myActions.USER_UPDATE_MODIFIED_ADM({
      ENS_ID: value,
    })
  }

  get usr_civilite() {
    return this.modified.USR_CIVILITE!
  }
  set usr_civilite(value: number) {
    this.$store.myActions.USER_UPDATE_MODIFIED_ADM({
      USR_CIVILITE: value,
    })
  }

  get usr_nom() {
    return this.modified.USR_NOM!
  }
  set usr_nom(value: string) {
    this.$store.myActions.USER_UPDATE_MODIFIED_ADM({
      USR_NOM: value,
    })
  }

  get usr_prenom() {
    return this.modified.USR_PRENOM!
  }
  set usr_prenom(value: string) {
    this.$store.myActions.USER_UPDATE_MODIFIED_ADM({
      USR_PRENOM: value,
    })
  }

  get usr_login() {
    return this.modified.USR_LOGIN!
  }
  set usr_login(value: string) {
    this.$store.myActions.USER_UPDATE_MODIFIED_ADM({
      USR_LOGIN: value,
    })
  }

  get usr_email() {
    return this.modified.USR_EMAIL!
  }
  set usr_email(value: string) {
    this.$store.myActions.USER_UPDATE_MODIFIED_ADM({
      USR_EMAIL: value,
    })
  }

  get usr_tel() {
    return this.modified.USR_TEL!
  }
  set usr_tel(value: string) {
    this.$store.myActions.USER_UPDATE_MODIFIED_ADM({
      USR_TEL: value,
    })
  }

  get usr_note_interne() {
    return this.modified.USR_NOTE_INTERNE!
  }
  set usr_note_interne(value: string) {
    this.$store.myActions.USER_UPDATE_MODIFIED_ADM({
      USR_NOTE_INTERNE: value,
    })
  }

  get usr_photo_url() {
    return this.modified.USR_PHOTO_URL!
  }
  set usr_photo_url(value: string) {
    this.$store.myActions.USER_UPDATE_MODIFIED_ADM({
      USR_PHOTO_URL: value,
    })
  }

  get usr_roles(): Array<string> {
    return this.modified.ROLES!
  }
  set usr_roles(value: Array<string>) {
    this.$store.myActions.USER_UPDATE_MODIFIED_ADM({
      ROLES: value,
    })
  }
}
</script>
